import { Card, Text } from '@change/ds-core-ui';

import { SubmitButton } from '../../../SubmitButton';
import { useSavedPaymentMethodButton } from '../../hooks/useSavedPaymentMethodButton';
import { PaypalButton } from '../PaypalButton';
import type { SavedPaymentMethodContent } from '../SavedPaymentMethodSlot/types';
import { getContent } from '../SavedPaymentMethodSlot/utils/getContent';
import { StripeWalletWrapper } from '../StripeWalletWrapper';

type Props = {
	paymentMethod: SavedPaymentMethodContent;
};

export const SavedMethodCard: React.FC<Props> = ({ paymentMethod }) => {
	const content = getContent({ paymentMethod, variant: 'variant_2' });

	const {
		data: { loading },
		actions: { onClick },
	} = useSavedPaymentMethodButton();

	if (paymentMethod.type === 'applePay' || paymentMethod.type === 'googlePay')
		return <StripeWalletWrapper selectedPaymentMethod={paymentMethod.type} />;

	if (paymentMethod.type === 'paypal') return <PaypalButton selectedPaymentMethod={paymentMethod.type} />;

	return (
		<Card className="elevation-low p-6">
			<div className="flex flex-col gap-11">
				<div className="flex flex-row items-center gap-5">
					{content.icon}
					<div className="flex flex-col gap-1">
						<Text size="small" className="text-typography-weak">
							{/* TODO: add translation when productized */}
							Last used
						</Text>
						<Text>{content.label}</Text>
					</div>
				</div>
				<SubmitButton disabled={false} loading={loading} onClick={async () => onClick(paymentMethod.type)} />
			</div>
		</Card>
	);
};
